// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2XWTN","productName":"Table_productName__1CJQZ"};